import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { IBlog, IDriverClubNews } from '../blogs/blog';
import { BlogService } from '../blogs/blog.service';
import { BlogType } from './blogtypes';
declare var $: any;
@Component({
  templateUrl: "./driversclub.component.html"
})
export class DriversclubComponent implements OnInit, AfterViewInit {
  public pageTitle: string = 'Drivers Club';
  newsList: IDriverClubNews[];
  blogsList: IBlog[];
  category: string;
  dtitle: string = "Drivers Club Offers";
  constructor(private authService: AuthService,
    private appCommonService: AppCommonService,
    public blogService: BlogService
  ) {
    this.appCommonService.pageContentAdditionalClass = "home-page main-page";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit() {
    this.category = BlogType.mydriversclub;
    this.loadBlogsList();
    this.loadNewsList();
    window.scrollTo(0, 0);
  }

  ngAfterViewInit() {
    this.appCommonService.loadRequiredJS();
    $('.tabs-left li a').hover(function () {      
      $(this).trigger('click');
    });
    $('.sliderformobile').bxSlider({
      auto: true,
      pager: true,
      controls: false,
      touchEnabled: true,
      adaptiveHeight: true
    });

    $('#play_video').on('show.bs.modal', function (e) {
      $("#video").attr('src', "https://www.youtube.com/embed/emRtdtuF81M?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#play_video').on('hide.bs.modal', function (e) {
      $("#video").attr('src', "https://www.youtube.com/embed/emRtdtuF81M");
    });
  }

  loadNewsList() {
    this.blogService.getDriversClubNewsList()
      .subscribe(
      (newsitems: IDriverClubNews[]) => {
        this.newsList = newsitems;
      },
      (error: any) => {
        this.blogService.showError("Drivers club news retrieval problem", <any>error)
      }
      );
  }

  loadBlogsList() {
    this.blogService.getBlogsList(this.category)
      .subscribe(
      (blogs: IBlog[]) => {
        this.blogsList = blogs;
      },
      (error: any) => {
        this.blogService.showError("Blog retrieval problem", <any>error)
      }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/driversclub.component.ts